import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UnsubscribeForm } from 'src/app/models/iblacklist.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService {

  private url = 'unsubscribe';
  private api = environment.apiUrl;

  constructor(private http: HttpClient) { }

  unsubscribe(form: UnsubscribeForm) {
    return this.http.post(`${this.api}${this.url}`, form);
  }

  deleteBadEmails(form: string[]) {
    return this.http.post(`${this.api}${this.url}/delete`, form);
  }
}
